import { NotificationNoReadEmptyState } from 'ui/illustrations/NotificationNoReadEmptyState';
import { ErrorStatePageError } from 'ui/illustrations';
import {
  LaunchpadLoadingContainer,
  LaunchpadStateContainer,
  LaunchpadStateTitle,
  LaunchpadStateDescription,
  StyledTextButton,
} from './LaunchpadState.styled';
import { ActivityItemLoading } from './ActivityFeed/ActivityItemLoading';

type BaseLaunchpadStateProps = {
  title?: string;
  description?: string | JSX.Element;
  Illustration: React.FC;
};

export const LAUNCHPAD_STATES_TEST_IDS = {
  LOADING_STATE: 'launchpad-loading-state',
  ERROR_STATE: 'launchpad-error-state',
  ZERO_STATE: 'launchpad-zero-state',
};

const BaseLaunchpadState = ({
  Illustration,
  title,
  description,
  ...props
}: BaseLaunchpadStateProps) => {
  return (
    <LaunchpadStateContainer {...props}>
      <Illustration />
      {title && <LaunchpadStateTitle>{title}</LaunchpadStateTitle>}
      {description && <LaunchpadStateDescription>{description}</LaunchpadStateDescription>}
    </LaunchpadStateContainer>
  );
};

export const LoadingState = ({ initialDisplayMax }: { initialDisplayMax: number }) => {
  return (
    <LaunchpadLoadingContainer data-test={LAUNCHPAD_STATES_TEST_IDS.LOADING_STATE}>
      {Array.from({ length: initialDisplayMax }, (_, i) => (
        <ActivityItemLoading key={i} />
      ))}
    </LaunchpadLoadingContainer>
  );
};

export const ErrorState = ({ onRetry }: { onRetry: () => void }) => {
  return (
    <BaseLaunchpadState
      data-test={LAUNCHPAD_STATES_TEST_IDS.ERROR_STATE}
      title="We've hit a snag"
      description={
        <>
          Sorry, we’re having trouble loading recent activity. Come back again later or try{' '}
          <StyledTextButton onClick={onRetry}>refreshing the page.</StyledTextButton>
        </>
      }
      Illustration={ErrorStatePageError}
    />
  );
};

export const ZeroState = ({ onClear }: { onClear: () => void }) => {
  return (
    <BaseLaunchpadState
      data-test={LAUNCHPAD_STATES_TEST_IDS.ZERO_STATE}
      title="Nothing to show here"
      description={
        <>
          You can <StyledTextButton onClick={onClear}>clear your filters</StyledTextButton> to view
          more results.
        </>
      }
      Illustration={NotificationNoReadEmptyState}
    />
  );
};
